import { Grid, TextField, pn } from "@compass/core";
import { DiplomaType, DiplomaTypeEditResource, DiplomaTypeViewResource } from "generated/openApi";
import { CrudMode, ValidationErrors } from "@compass/core";
import { Input } from "components";
import produce from "immer";

export const BasicInfo = (props: {
    crudMode: CrudMode;
    diplomaType: DiplomaType;
    setDiplomaType: (diplomaType: DiplomaType) => void;
    viewResource: DiplomaTypeViewResource;
    editResource: DiplomaTypeEditResource;
    validationErrors: ValidationErrors;
}) => {
    const { crudMode, diplomaType, setDiplomaType, editResource, validationErrors } = props;
    const isView = crudMode === "view";
    const properties = props.viewResource.properties || [];

    const handleChange = (property: keyof DiplomaType, value: any) => {
        setDiplomaType({
            ...diplomaType,
            [property]: value,
        });
    };

    const nameField = () => {
        return (
            <TextField
                label="Name"
                value={diplomaType.name || ""}
                onChange={(e) => handleChange("name", e.target.value)}
                error={!!validationErrors?.[pn<DiplomaType>("name")]}
                disabled={isView}
            />
        )
    };

    const taprField = () => {
        const propertyName = pn<DiplomaType>("tapr");
        const property = properties.find((x) => x.propertyName === propertyName);

        return (
            <Input
                modelProperty={property}
                disabled={isView}
                errors={props.validationErrors[propertyName]}
                value={props.diplomaType.tapr}
                onChange={(e) =>
                    props.setDiplomaType(
                        produce(props.diplomaType, (draft) => {
                            draft.tapr = parseFloat(e.target.value);
                        })
                    )
                }
            />
        )
    };

    return (
        <Grid container spacing="sm">
            <Grid item xs={12} md={6}>
                {nameField()}
            </Grid>

            <Grid item xs={12} md={6}>
                {taprField()}
            </Grid>
        </Grid>
    );
};
